import React, { useEffect, useState } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import GitHubIcon from "@mui/icons-material/GitHub";
import ProfileIcon from "@mui/icons-material/PersonSharp";
import ProjectsIcon from "@mui/icons-material/DataSaverOff";

import MenuItemNav from "./MenuItemNav";

export default function Sidebar() {
  return (
    <React.Fragment>
      <MenuItemNav
        to="/projects"
        icon={<ProjectsIcon />}
        title="Projetos"
      />
      <MenuItemNav
        to="/dashboard"
        icon={<DashboardIcon />}
        title="Dashboard"
      />
      <MenuItemNav
        to="/repositories"
        icon={<GitHubIcon />}
        title="Repositórios"
      />
      <MenuItemNav
        to="/profile"
        icon={<ProfileIcon />}
        title="Perfil"
      />
    </React.Fragment>
  );
}
